(function (window, document) {
  'use strict';

  var APP_NAMESPACE = 'StorefrontTracking';
  var LEGACY_NAMESPACE = 'ProtoArcTracking';
  var existingTracking = window[APP_NAMESPACE] || window[LEGACY_NAMESPACE];

  if (existingTracking && existingTracking.version) {
    window[APP_NAMESPACE] = existingTracking;
    window[LEGACY_NAMESPACE] = existingTracking;
    return;
  }

  var config = window.__TRACKING_CONFIG__ || {};
  var context = window.__TRACKING_CONTEXT__ || {};
  var featureFlags = config.feature_flags || {};
  var eventCatalog = config.event_catalog || {};
  var state = {
    gtagPromise: null,
    gtagConfigured: {},
    ownsGtag: false,
    createdGtagStub: false,
    consentDefaultSet: false,
    consentKey: null,
    privacyGeneration: 0,
    privacyBoundaryKey: null,
    privacyLoading: false,
    privacyRetryTimer: null,
    privacyRetryCount: 0,
    privacyReadyNotified: false,
    ga4UserId: null,
    identitySyncPromise: null,
    identitySyncUser: null,
    onceKeys: {}
  };

  function log() {
    if (!featureFlags.debug || !window.console || !console.log) return;
    console.log.apply(console, ['[StorefrontTracking]'].concat(Array.prototype.slice.call(arguments)));
  }

  function warn() {
    if (!window.console || !console.warn) return;
    console.warn.apply(console, ['[StorefrontTracking]'].concat(Array.prototype.slice.call(arguments)));
  }

  function cleanObject(source) {
    var output = {};

    Object.keys(source || {}).forEach(function (key) {
      var value = source[key];

      if (value === null || typeof value === 'undefined') return;
      if (Array.isArray(value) && value.length === 0) return;
      output[key] = value;
    });

    return output;
  }

  function normalizeNumber(value) {
    if (typeof value === 'number' && !isNaN(value)) return value;
    if (typeof value === 'string' && value.trim() !== '') {
      var parsed = Number(value);
      if (!isNaN(parsed)) return parsed;
    }
    return null;
  }

  function normalizeItems(items) {
    return Array.isArray(items) ? items : [];
  }

  function getGa4UserId() {
    context = window.__TRACKING_CONTEXT__ || context;
    var value = Object.prototype.hasOwnProperty.call(context, 'customer_id') ? context.customer_id : (context.customer && context.customer.id);

    if (value === null || typeof value === 'undefined' || value === '') {
      return null;
    }

    return String(value);
  }

  function generateEventId(name) {
    return [
      name,
      Date.now(),
      Math.random().toString(36).slice(2, 10)
    ].join('_');
  }

  function getAttributionPayload() {
    var attributionApi = window.ProtoArcAttribution;

    if (!attributionApi || typeof attributionApi.get !== 'function') {
      return {};
    }

    try {
      return cleanObject(attributionApi.get() || {});
    } catch (error) {
      log('Attribution payload unavailable.', error);
      return {};
    }
  }

  function getConsentState() {
    var result = { analytics: false, marketing: false, sale_of_data: false, source: 'shopify_unavailable' };
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return result;
    var methods = { analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed', sale_of_data: 'saleOfDataAllowed' };
    Object.keys(methods).forEach(function (key) {
      try {
        if (typeof privacy[methods[key]] === 'function') {
          var value = privacy[methods[key]]();
          result[key] = value === true;
          result[key + '_known'] = typeof value === 'boolean';
        }
      } catch (error) {
        result[key + '_known'] = false;
      }
    });
    if (result.analytics_known && result.marketing_known) result.source = 'shopify_customer_privacy';
    return result;
  }

  function identityIsCurrent() {
    var attribution = window.ProtoArcAttribution;
    return !attribution || typeof attribution.isIdentityCurrent !== 'function' || attribution.isIdentityCurrent();
  }

  function setGtagConsent() {
    if (!state.ownsGtag || typeof window.gtag !== 'function') return;
    var consent = getConsentState();
    var values = {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: consent.marketing ? 'granted' : 'denied',
      ad_user_data: consent.marketing && consent.sale_of_data ? 'granted' : 'denied',
      ad_personalization: consent.marketing && consent.sale_of_data ? 'granted' : 'denied'
    };
    if (!state.consentDefaultSet) {
      window.gtag('consent', 'default', {
        analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
      });
      state.consentDefaultSet = true;
    }
    var key = JSON.stringify(values);
    if (key !== state.consentKey) {
      window.gtag('consent', 'update', values);
      state.consentKey = key;
    }
  }

  function clearIdentityStorage() {
    try {
      var storage = window.sessionStorage;
      for (var i = storage.length - 1; i >= 0; i--) {
        var key = storage.key(i);
        if (key === 'pa_ga4_identity_v2' || (key && key.indexOf('pa_ga4_identity:') === 0)) storage.removeItem(key);
      }
    } catch (error) {}
  }

  function setGa4Identity(userId) {
    var ga4Id = config.ga4 && config.ga4.measurement_id;
    if (!ga4Id || !state.gtagConfigured[ga4Id] || typeof window.gtag !== 'function') return;
    if (state.ga4UserId === userId) return;
    window.gtag('config', ga4Id, { send_page_view: false, user_id: userId });
    state.ga4UserId = userId;
  }

  function configureAllowedTargets() {
    var consent = getConsentState();
    var ga4Id = featureFlags.ga4_enabled && config.ga4 && config.ga4.measurement_id;
    var adsId = featureFlags.google_ads_enabled && config.google_ads && config.google_ads.aw_id;
    setGtagConsent();
    if (ga4Id && consent.analytics && identityIsCurrent()) {
      var userId = getGa4UserId();
      if (!state.gtagConfigured[ga4Id]) {
        window.gtag('config', ga4Id, { send_page_view: false, debug_mode: !!featureFlags.debug, user_id: userId });
        state.gtagConfigured[ga4Id] = true;
        state.ga4UserId = userId;
      } else {
        setGa4Identity(userId);
      }
    } else {
      setGa4Identity(null);
    }
    if (adsId && consent.marketing && !state.gtagConfigured[adsId]) {
      window.gtag('config', adsId, { send_page_view: false, allow_enhanced_conversions: consent.sale_of_data });
      state.gtagConfigured[adsId] = true;
    }
    return !!((ga4Id && consent.analytics && identityIsCurrent()) || (adsId && consent.marketing));
  }

  function ensureGtag() {
    var consent = getConsentState();
    var ga4Id = featureFlags.ga4_enabled && consent.analytics && config.ga4 && config.ga4.measurement_id;
    var adsId = featureFlags.google_ads_enabled && consent.marketing && config.google_ads && config.google_ads.aw_id;
    var primaryId = ga4Id || adsId;
    if (!primaryId) return Promise.resolve(false);
    if (!state.gtagPromise) {
      var existingScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
      var hadGtag = typeof window.gtag === 'function';
      var hadDataLayer = window.dataLayer && window.dataLayer.length > 0;
      // A business queue alone does not establish an active consent owner.
      // Wait for its tag to become available instead of adding an unmanaged tag.
      if (!hadGtag && !existingScript && hadDataLayer) return Promise.resolve(false);
      if (!hadGtag && !existingScript && !hadDataLayer) state.ownsGtag = true;
      window.dataLayer = window.dataLayer || [];
      if (!hadGtag) {
        window.gtag = function () { window.dataLayer.push(arguments); };
        state.createdGtagStub = true;
      }
      setGtagConsent();
      state.gtagPromise = new Promise(function (resolve) {
        if (existingScript || (hadGtag && !state.createdGtagStub)) { resolve(true); return; }
        var script = document.createElement('script');
        var settled = false;
        var timeoutId = window.setTimeout(function () { finish(false); }, 15000);
        function finish(ok) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          if (!ok && script.parentNode) script.parentNode.removeChild(script);
          resolve(ok);
        }
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(primaryId);
        script.onload = function () { finish(true); };
        script.onerror = function () { finish(false); };
        window.gtag('js', new Date());
        document.head.appendChild(script);
      }).then(function (ready) {
        if (!ready) state.gtagPromise = null;
        return ready;
      });
    }
    return state.gtagPromise.then(function (ready) {
      return ready && configureAllowedTargets();
    }).catch(function () {
      state.gtagPromise = null;
      return false;
    });
  }

  function syncGa4Identity() {
    var ga4Id = config.ga4 && config.ga4.measurement_id;
    var userId = getGa4UserId();
    var consent = getConsentState();
    if (!featureFlags.ga4_identity_sync_enabled || !ga4Id || !userId || !consent.analytics || !identityIsCurrent()) {
      setGa4Identity(null);
      if (!userId || !consent.analytics || !identityIsCurrent()) clearIdentityStorage();
      state.identitySyncPromise = null;
      state.identitySyncUser = null;
      return Promise.resolve(false);
    }
    if (state.identitySyncPromise && state.identitySyncUser === userId) return state.identitySyncPromise;
    var generation = state.privacyGeneration;
    state.identitySyncUser = userId;
    var attempt = ensureGtag().then(function (ready) {
      if (!ready || generation !== state.privacyGeneration || !getConsentState().analytics ||
          getGa4UserId() !== userId || !identityIsCurrent() || typeof window.gtag !== 'function') return false;
      var attribution = getAttributionPayload();
      var marker = JSON.stringify({ measurement_id: ga4Id, user_id: userId, session_id: attribution.pa_session_id || null });
      try { if (window.sessionStorage.getItem('pa_ga4_identity_v2') === marker) return true; } catch (error) {}
      window.gtag('event', 'customer_identity_sync', {
        send_to: ga4Id, user_id: userId, identity_source: 'shopify_logged_in', customer_status: 'authenticated'
      });
      try { window.sessionStorage.setItem('pa_ga4_identity_v2', marker); } catch (error) {}
      return true;
    }).catch(function () { return false; });
    state.identitySyncPromise = attempt;
    return attempt.then(function (result) {
      if (state.identitySyncPromise === attempt) state.identitySyncPromise = null;
      return result;
    });
  }

  function handlePrivacyChange() {
    var consent = getConsentState();
    var identityCurrent = identityIsCurrent();
    var boundary = JSON.stringify([consent.analytics, consent.marketing, consent.sale_of_data,
      !!consent.analytics_known, !!consent.marketing_known, !!consent.sale_of_data_known, getGa4UserId(), identityCurrent]);
    if (boundary !== state.privacyBoundaryKey) {
      state.privacyGeneration += 1;
      state.privacyBoundaryKey = boundary;
      state.identitySyncPromise = null;
    }
    setGtagConsent();
    if (!consent.analytics || !identityIsCurrent()) {
      setGa4Identity(null);
      clearIdentityStorage();
    }
    syncGa4Identity();
  }

  function loadPrivacyApi() {
    var shopify = window.Shopify;
    if (getConsentState().source === 'shopify_customer_privacy') {
      if (state.privacyRetryTimer !== null) window.clearTimeout(state.privacyRetryTimer);
      state.privacyRetryTimer = null;
      if (!state.privacyReadyNotified) {
        state.privacyReadyNotified = true;
        document.dispatchEvent(new CustomEvent('tracking:privacy-ready'));
      }
      return;
    }
    // Another app may be loading the shared API, or the loader may become ready
    // later. Keep this bounded and never grant permission while it is unknown.
    if (state.privacyRetryTimer === null && state.privacyRetryCount < 30) {
      state.privacyRetryTimer = window.setTimeout(function () {
        state.privacyRetryTimer = null;
        state.privacyRetryCount += 1;
        loadPrivacyApi();
      }, 1000);
    }
    if (!shopify || typeof shopify.loadFeatures !== 'function' || state.privacyLoading) return;
    state.privacyLoading = true;
    try {
      // Impact already loads 0.1 on this store; asking for 0.2 causes a real
      // version-conflict error instead of upgrading the shared instance.
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        state.privacyLoading = false;
        if (getConsentState().source === 'shopify_customer_privacy') loadPrivacyApi();
      });
    } catch (error) { state.privacyLoading = false; }
  }

  function bindPrivacyLifecycle() {
    document.addEventListener('visitorConsentCollected', handlePrivacyChange);
    document.addEventListener('tracking:privacy-ready', handlePrivacyChange);
    document.addEventListener('tracking:identity-changed', function () {
      if (window.ProtoArcAttribution && typeof window.ProtoArcAttribution.refresh === 'function') window.ProtoArcAttribution.refresh();
      handlePrivacyChange();
    });
    window.addEventListener('focus', function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        // Renew an expired local session before checking the page identity.
        // Attribution refresh still rejects an identity replaced by another tab.
        if (window.ProtoArcAttribution && typeof window.ProtoArcAttribution.refresh === 'function') window.ProtoArcAttribution.refresh();
        handlePrivacyChange();
      }
      else {
        state.privacyRetryCount = 0;
        loadPrivacyApi();
      }
    });
    window.addEventListener('storage', function (event) {
      if (!event.key || event.key === 'pa_attribution_v2' || event.key === 'pa_session_v2') {
        if (!getConsentState().analytics || !identityIsCurrent()) {
          state.privacyGeneration += 1;
          setGa4Identity(null);
          clearIdentityStorage();
        }
      }
    });
    loadPrivacyApi();
  }


  function shouldAttachItems(name) {
    return [
      'view_item',
      'view_item_list',
      'select_item',
      'add_to_cart',
      'view_cart',
      'begin_checkout',
      'purchase'
    ].indexOf(name) !== -1;
  }

  function buildEventPayload(name, payload) {
    context = window.__TRACKING_CONTEXT__ || context;
    var page = context.page || {};
    var ecommerce = context.ecommerce || {};
    var cart = context.cart || {};
    var attribution = getAttributionPayload();
    var merged = Object.assign({
      event_id: generateEventId(name),
      event_time: new Date().toISOString(),
      brand: config.brand || context.brand || null,
      page_type: context.page_type || page.type || null,
      template_name: context.template_name || page.template_name || null,
      page_path: page.path || window.location.pathname,
      page_title: page.title || document.title || null,
      currency: ecommerce.currency || context.currency || (context.shop && context.shop.currency) || null,
      customer_status: context.customer_status || (context.customer && context.customer.status) || 'guest'
    }, attribution, payload || {});

    if (typeof merged.customer_id === 'undefined' && typeof context.customer_id !== 'undefined') {
      merged.customer_id = context.customer_id;
    }

    if (typeof merged.value === 'undefined' || merged.value === null) {
      if (name === 'view_cart' && typeof cart.total_value !== 'undefined') {
        merged.value = cart.total_value;
      } else if (typeof ecommerce.value !== 'undefined') {
        merged.value = ecommerce.value;
      }
    }

    if (shouldAttachItems(name) && normalizeItems(merged.items).length === 0) {
      if (name === 'view_cart' && normalizeItems(cart.items).length) {
        merged.items = cart.items;
      } else {
        merged.items = ecommerce.items;
      }
    }

    if (name === 'search' && typeof merged.search_term === 'undefined') {
      merged.search_term = ecommerce.search_term;
    }

    if (name === 'view_item_list') {
      if (typeof merged.item_list_id === 'undefined') merged.item_list_id = ecommerce.item_list_id;
      if (typeof merged.item_list_name === 'undefined') merged.item_list_name = ecommerce.item_list_name;
      if (typeof merged.collection_id === 'undefined') merged.collection_id = ecommerce.collection_id;
      if (typeof merged.collection_name === 'undefined') merged.collection_name = ecommerce.collection_name;
    }

    if (shouldAttachItems(name)) {
      merged.items = normalizeItems(merged.items);
    }

    if (merged.value !== null && typeof merged.value !== 'undefined') {
      var numericValue = normalizeNumber(merged.value);
      if (numericValue !== null) {
        merged.value = numericValue;
      }
    }

    return merged;
  }

  function buildGa4Params(name, payload) {
    return cleanObject({
      send_to: config.ga4 && config.ga4.measurement_id,
      event_id: payload.event_id,
      transaction_id: payload.transaction_id,
      page_type: payload.page_type,
      template_name: payload.template_name,
      page_path: payload.page_path,
      page_title: payload.page_title,
      currency: payload.currency,
      value: normalizeNumber(payload.value),
      items: normalizeItems(payload.items),
      item_list_id: payload.item_list_id,
      item_list_name: payload.item_list_name,
      collection_id: payload.collection_id,
      collection_name: payload.collection_name,
      search_term: payload.search_term,
      customer_status: payload.customer_status,
      source_link_id: payload.source_link_id,
      pa_anon_id: payload.pa_anon_id,
      pa_session_id: payload.pa_session_id,
      first_landing_url: payload.first_landing_url,
      first_touch_at: payload.first_touch_at,
      first_utm_source: payload.first_utm_source,
      first_utm_medium: payload.first_utm_medium,
      first_utm_campaign: payload.first_utm_campaign,
      first_utm_id: payload.first_utm_id,
      first_utm_term: payload.first_utm_term,
      first_utm_content: payload.first_utm_content,
      latest_utm_source: payload.latest_utm_source,
      latest_utm_medium: payload.latest_utm_medium,
      latest_utm_campaign: payload.latest_utm_campaign,
      latest_utm_id: payload.latest_utm_id,
      latest_utm_term: payload.latest_utm_term,
      latest_utm_content: payload.latest_utm_content,
      latest_ref: payload.latest_ref,
      current_page_url: payload.current_page_url,
      resource: payload.resource,
      resource_id: payload.resource_id,
      slot: payload.slot,
      delta: payload.delta
    });
  }

  function dispatchGa4(name, payload) {
    if (!featureFlags.ga4_event_forwarding_enabled) {
      return Promise.resolve({ destination: 'ga4', status: 'skipped', reason: 'native_shopify_ga4_is_source_of_truth' });
    }

    if (!featureFlags.ga4_enabled) {
      return Promise.resolve({ destination: 'ga4', status: 'skipped', reason: 'disabled' });
    }

    if (!getConsentState().analytics) {
      return Promise.resolve({ destination: 'ga4', status: 'skipped', reason: 'analytics_consent_denied' });
    }

    var generation = state.privacyGeneration;
    var userId = getGa4UserId();
    return ensureGtag().then(function (ready) {
      if (!getConsentState().analytics || generation !== state.privacyGeneration || userId !== getGa4UserId() || !identityIsCurrent()) {
        return { destination: 'ga4', status: 'skipped', reason: 'consent_or_identity_changed' };
      }
      if (!ready || typeof window.gtag !== 'function') {
        return { destination: 'ga4', status: 'failed', reason: 'gtag_unavailable' };
      }

      var params = buildGa4Params(name, payload);
      window.gtag('event', name, params);
      log('GA4 event submitted', name);

      return { destination: 'ga4', status: 'submitted', receipt: 'gtag_queue', data: params };
    });
  }

  function buildAdsParams(payload, sendTo) {
    return cleanObject({
      send_to: sendTo,
      value: normalizeNumber(payload.value),
      currency: payload.currency,
      transaction_id: payload.transaction_id
    });
  }

  function dispatchGoogleAds(name, payload) {
    var adsConfig = config.google_ads || {};
    var conversionConfig = adsConfig.conversions && adsConfig.conversions[name];
    var sendTo = conversionConfig && conversionConfig.send_to;

    if (!featureFlags.google_ads_enabled) {
      return Promise.resolve({ destination: 'google_ads', status: 'skipped', reason: 'disabled' });
    }

    if (!sendTo) {
      return Promise.resolve({ destination: 'google_ads', status: 'skipped', reason: 'missing_mapping' });
    }

    if (!getConsentState().marketing) {
      return Promise.resolve({ destination: 'google_ads', status: 'skipped', reason: 'marketing_consent_denied' });
    }

    var generation = state.privacyGeneration;
    var userId = getGa4UserId();
    return ensureGtag().then(function (ready) {
      var consent = getConsentState();
      if (!consent.marketing || generation !== state.privacyGeneration || userId !== getGa4UserId()) {
        return { destination: 'google_ads', status: 'skipped', reason: 'consent_or_identity_changed' };
      }
      if (!ready || typeof window.gtag !== 'function') {
        return { destination: 'google_ads', status: 'failed', reason: 'gtag_unavailable' };
      }

      var userData = adsConfig.enhanced_conversions && consent.sale_of_data && payload.user_data || null;
      window.gtag('set', 'user_data', userData);

      var params = buildAdsParams(payload, sendTo);
      window.gtag('event', 'conversion', params);
      window.gtag('set', 'user_data', null);
      log('Google Ads conversion submitted', name);

      return { destination: 'google_ads', status: 'submitted', receipt: 'gtag_queue', data: params };
    });
  }

  function dispatchFirstParty(name, payload) {
    var likesConfig = config.first_party && config.first_party.likes;

    if (!featureFlags.first_party_enabled) {
      return Promise.resolve({ destination: 'first_party', status: 'skipped', reason: 'disabled' });
    }

    if (name !== 'like_click') {
      return Promise.resolve({ destination: 'first_party', status: 'skipped', reason: 'unsupported_event' });
    }

    if (!likesConfig || !likesConfig.endpoint) {
      return Promise.resolve({ destination: 'first_party', status: 'skipped', reason: 'missing_endpoint' });
    }

    if (likesConfig.require_login && !context.customer_id && !payload.customer_id) {
      return Promise.resolve({ destination: 'first_party', status: 'skipped', reason: 'login_required' });
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeoutId = null;
    var headers = {
      'Content-Type': 'application/json'
    };

    if (likesConfig.open_token) {
      headers['X-Worker-Open-Token'] = likesConfig.open_token;
    }

    if (controller) {
      timeoutId = window.setTimeout(function () {
        controller.abort();
      }, likesConfig.timeout_ms || 15000);
    }

    return fetch(likesConfig.endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(cleanObject({
        brand: config.brand,
        resource: payload.resource || 'page',
        resource_id: payload.resource_id || 'unknown',
        event: payload.event || name,
        slot: payload.slot || 'default',
        delta: normalizeNumber(payload.delta) || 1,
        customer_id: payload.customer_id || context.customer_id,
        page_path: payload.page_path
      })),
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (timeoutId) window.clearTimeout(timeoutId);

      return response.text().then(function (rawText) {
        var data = {};

        try {
          data = rawText ? JSON.parse(rawText) : {};
        } catch (error) {
          data = { status: 'error', error: 'invalid_json' };
        }

        if (!data || typeof data !== 'object' || Array.isArray(data)) data = { status: 'error', error: 'invalid_response' };
        if (!response.ok || data.error || data.status === 'error' || data.ok === false || data.success === false) {
          return {
            destination: 'first_party',
            status: 'failed',
            error: data.error || ('HTTP ' + response.status),
            data: data
          };
        }

        return {
          destination: 'first_party',
          status: 'submitted',
          receipt: 'http_response',
          data: data
        };
      });
    }).catch(function (error) {
      if (timeoutId) window.clearTimeout(timeoutId);

      return {
        destination: 'first_party',
        status: 'failed',
        error: error && error.name === 'AbortError' ? 'timeout' : (error && error.message) || 'request_failed'
      };
    });
  }

  function resolveDestinations(name, options) {
    if (options && Array.isArray(options.destinations) && options.destinations.length) {
      return options.destinations;
    }

    return (eventCatalog[name] && eventCatalog[name].destinations) || [];
  }

  function getOnceKey(name, payload, options) {
    if (options && options.onceKey) return options.onceKey;
    if (eventCatalog[name] && eventCatalog[name].once_per_page) return name + ':' + (payload.page_path || window.location.pathname);
    return null;
  }

  function dispatch(name, payload, destinations) {
    var destinationResults = {};
    var tasks = destinations.filter(function (value, index, values) { return values.indexOf(value) === index; }).map(function (destination) {
      var dispatcher;
      if (destination === 'ga4') dispatcher = dispatchGa4;
      if (destination === 'google_ads') dispatcher = dispatchGoogleAds;
      if (destination === 'first_party') dispatcher = dispatchFirstParty;
      if (!dispatcher) {
        destinationResults[destination] = { destination: destination, status: 'skipped', reason: 'unknown_destination' };
        return Promise.resolve();
      }
      return Promise.resolve().then(function () { return dispatcher(name, payload); }).then(function (result) {
        destinationResults[destination] = result;
      }).catch(function () {
        destinationResults[destination] = { destination: destination, status: 'failed', error: 'dispatcher_failed' };
      });
    });
    return Promise.all(tasks).then(function () { return destinationResults; });
  }

  function summarizeResults(destinations) {
    var counts = { submitted: 0, skipped: 0, failed: 0 };
    Object.keys(destinations).forEach(function (key) {
      var status = destinations[key].status;
      if (typeof counts[status] === 'number') counts[status] += 1;
      else counts.failed += 1;
    });
    return {
      status: counts.submitted ? (counts.failed ? 'partial' : 'submitted') : (counts.failed ? 'failed' : 'skipped'),
      counts: counts
    };
  }

  function emitTrackingResult(result) {
    var detail = { name: result.event, payload: result.payload, destinations: result.destinations, status: result.status, counts: result.counts };
    document.dispatchEvent(new CustomEvent('tracking:result', { detail: detail }));
    if (result.counts.submitted > 0) document.dispatchEvent(new CustomEvent('tracking:sent', { detail: detail }));
  }

  function track(name, payload, options) {
    var normalizedPayload = buildEventPayload(name, payload);
    var destinations = resolveDestinations(name, options || {});
    var onceKey = getOnceKey(name, normalizedPayload, options || {});
    var reason = onceKey && state.onceKeys[onceKey] ? 'duplicate' : (!destinations.length ? 'no_destinations' : null);
    if (reason) {
      var skipped = { event: name, payload: normalizedPayload, status: 'skipped', reason: reason, destinations: {}, counts: { submitted: 0, skipped: 0, failed: 0 } };
      emitTrackingResult(skipped);
      return Promise.resolve(skipped);
    }
    if (onceKey) state.onceKeys[onceKey] = 'pending';
    return dispatch(name, normalizedPayload, destinations).then(function (destinationResults) {
      var summary = summarizeResults(destinationResults);
      if (onceKey) {
        if (summary.counts.submitted) state.onceKeys[onceKey] = 'submitted';
        else delete state.onceKeys[onceKey];
      }
      var result = { event: name, payload: normalizedPayload, status: summary.status, counts: summary.counts, destinations: destinationResults };
      emitTrackingResult(result);
      return result;
    });
  }


  function trackAutoPageEvents() {
    if (!featureFlags.auto_page_events) return;

    track('page_view', {}, { onceKey: 'page_view:' + (context.page && context.page.path || window.location.pathname) });

    if (context.page_type === 'product' && normalizeItems(context.ecommerce && context.ecommerce.items).length) {
      track('view_item');
      return;
    }

    if (context.page_type === 'collection' && normalizeItems(context.ecommerce && context.ecommerce.items).length) {
      track('view_item_list');
      return;
    }

    if (context.page_type === 'search' && context.ecommerce && context.ecommerce.search_term) {
      track('search', {
        search_term: context.ecommerce.search_term,
        value: context.ecommerce.value,
        items: context.ecommerce.items
      });
      return;
    }

    if (context.page_type === 'cart') {
      track('view_cart', {
        value: context.cart && context.cart.total_value,
        items: context.cart && context.cart.items
      });
    }
  }

  function bindCustomEvents() {
    document.addEventListener('tracking:event', function (event) {
      var detail = event.detail || {};

      if (!detail.name) return;
      track(detail.name, detail.payload || {}, detail.options || {});
    });

    [
      'select_item',
      'add_to_cart',
      'begin_checkout',
      'purchase',
      'generate_lead'
    ].forEach(function (eventName) {
      document.addEventListener('tracking:' + eventName, function (event) {
        track(eventName, (event && event.detail) || {});
      });
    });
  }

  function buildItemFromDataset(el) {
    if (!el || !el.dataset || !el.dataset.trackItemId) return [];

    return [cleanObject({
      item_id: el.dataset.trackItemId,
      product_id: el.dataset.trackProductId,
      sku: el.dataset.trackSku,
      item_name: el.dataset.trackItemName,
      item_brand: el.dataset.trackItemBrand,
      item_category: el.dataset.trackItemCategory,
      item_variant: el.dataset.trackItemVariant,
      price: normalizeNumber(el.dataset.trackPrice),
      quantity: normalizeNumber(el.dataset.trackQuantity) || 1
    })];
  }

  function bindDeclarativeElements() {
    document.addEventListener('click', function (event) {
      var el = event.target.closest('[data-track-event]');

      if (!el) return;

      var eventName = el.dataset.trackEvent;
      if (!eventName) return;

      track(eventName, cleanObject({
        resource: el.dataset.resource,
        resource_id: el.dataset.resourceId,
        slot: el.dataset.slot,
        value: normalizeNumber(el.dataset.trackValue),
        item_list_id: el.dataset.itemListId,
        item_list_name: el.dataset.itemListName,
        search_term: el.dataset.searchTerm,
        items: buildItemFromDataset(el)
      }));
    });

    document.addEventListener('click', function (event) {
      var el = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-track-begin-checkout]');

      if (!el) return;

      track('begin_checkout', {
        value: context.cart && context.cart.total_value,
        items: context.cart && context.cart.items
      });
    });
  }

  function init() {
    bindCustomEvents();
    bindDeclarativeElements();
    bindPrivacyLifecycle();

    if (featureFlags.ga4_event_forwarding_enabled) {
      trackAutoPageEvents();
    }
  }

  var api = {
    version: '1.1.0',
    config: config,
    context: context,
    getConsentState: getConsentState,
    getAttribution: getAttributionPayload,
    syncIdentity: syncGa4Identity,
    track: track,
    trackLeadSuccess: function (payload) {
      return track('generate_lead', payload || {});
    },
    trackAddToCartSuccess: function (payload) {
      return track('add_to_cart', payload || {});
    },
    trackPurchase: function (payload) {
      return track('purchase', payload || {});
    },
    trackBeginCheckout: function (payload) {
      return track('begin_checkout', payload || {});
    }
  };

  window[APP_NAMESPACE] = api;
  window[LEGACY_NAMESPACE] = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
